export default [
  {
    path: '/zoho-reports',
    name: 'zoho-reports',
    component: () => import('@/views/zoho-reports/CreateZohoReports.vue'),
    meta: {
      title: 'Reports',
      requiresAuth: true,
      action: 'browes',
      resource: 'zoho-reports',
      pageTitle: 'Reports',
      breadcrumb: [
        {
          text: 'Reports',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
